import React from "react";
import { Checkbox } from "antd";
import PropTypes from "prop-types";

import "./CheckBox.css";

const CheckBox = (props) => {
  CheckBox.propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
  };

  return (
    <Checkbox
      checked={props.checked}
      className={
        props.className
          ? `${props.className || ""} checkbox-container`
          : "checkbox-container"
      }
      disabled={props.disabled ? props.disabled : false}
      onChange={props.onChange}
    >
      {props.children}
    </Checkbox>
  );
};

export default CheckBox;
